import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Donor } from "types";

interface DonorsListState {
  donorsList: Donor[]
}

const initialState: DonorsListState = {
  donorsList: [],
};

const donorsListSlice = createSlice({
  name: 'donorsList',
  initialState,
  reducers: {
    updateDonorsList: (state, action: PayloadAction<DonorsListState>) => action.payload,
  }
})

export const {updateDonorsList} = donorsListSlice.actions;

export default donorsListSlice.reducer;
